import "./ScaffoldingInWandsworth.module.css";
import Header from "@/reusable_sections/Header";
import Wandsworth from "./sections/Wandsworth";
import WandsworthScaffolding from "./sections/WandsworthScaffolding";
import WandsworthAccess from "./sections/WandsworthAccess";
import FaqWandsworth from "./sections/FaqWandsworth";
import QuoteCta from "./sections/QuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInWandsworthPage() {
  return <div>
      <Header />
      <Wandsworth />
      <WandsworthScaffolding />
      <WandsworthAccess />
      <FaqWandsworth />
      <QuoteCta />
      <Footer />
    </div>;
}